// extracted by mini-css-extract-plugin
module.exports = {"disabled":"styles_disabled__3hTG3"};